const Agreenment = [
    'Я согласен на получение от Акционерного общества «Тойота Банк» (адрес: Россия, 127273, г. Москва, ул. Отрадная, дом 2Б стр. 1) (далее – Банк) информации, '
    + 'в т. ч. рекламного характера, касающейся банковских продуктов и услуг и/или услуг партнеров Банка, любым доступным для Банка способом, включая, но не ограничиваясь, '
    + 'следующие способы взаимодействия: текстовые сообщения (в т.ч. смс и push-уведомления), направляемых по почтовому адресу, номеру мобильного (личного)'
    + ' телефона, адресу электронной почты, предоставленным мной, устные сообщения по телефону, сообщения по сетям связи/электросвязи , в системах мгновенного обмена сообщениями '
    + '(мессенджерах), через мобильное приложение Банка.',
];

export default Agreenment;
